import { jwtDecode } from "jwt-decode";
export function getTokenData(token) {
  return jwtDecode(token);
}

export function isTokenCreatedToday(token) {
    try {
        const decoded = jwtDecode(token);

        if (!decoded.timestamp) return false;

        const tokenDate = new Date(decoded.timestamp * 1000); 
        const today = new Date();

        return (
            tokenDate.getFullYear() === today.getFullYear() &&
            tokenDate.getMonth() === today.getMonth() &&
            tokenDate.getDate() === today.getDate()
        );
    } catch (error) {
        return false;
    }
}
